import React from 'react';

function TabContent({ children }) {
  return (
    <div>{children}</div>
  );
}

export default TabContent;
